import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

export const AuthStart = () => {
  useEffect(() => {
    const clientId = '5eaa225e-61a5-407a-93b0-20d0eb819191';
    
    // Check if this is Microsoft OAuth flow
    const urlParams = new URLSearchParams(window.location.search);
    const authType = urlParams.get('type');
    const isMicrosoftAuth = authType === 'microsoft';
    
    // For Microsoft OAuth, include type parameter in callback URL
    const callbackPath = isMicrosoftAuth ? '/auth-callback?type=microsoft' : '/auth-callback';
    const redirectUri = encodeURIComponent(`${window.location.origin}${callbackPath}`);
    const scopes = encodeURIComponent('openid profile User.Read Contacts.ReadWrite');
    
    const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=${clientId}` +
      `&response_type=token` +
      `&redirect_uri=${redirectUri}` +
      `&scope=${scopes}` +
      `&response_mode=fragment`;
    
    console.log('[AuthStart] Auth Type:', isMicrosoftAuth ? 'Microsoft Graph' : 'Supabase');
    console.log('[AuthStart] Redirecting to Microsoft OAuth...', authUrl);
    console.log('[AuthStart] Redirect URI (after auth):', decodeURIComponent(redirectUri));
    window.location.href = authUrl;
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin mx-auto mb-4 text-blue-600" />
        <p className="text-sm text-gray-600">Redirecting to Microsoft login...</p>
      </div>
    </div>
  );
};
